import { Portal } from '@mui/material'
import React from 'react'

const LoaderScreen = () => (
  <Portal container={document.getElementById('root')}>
    <div className="loader">
      <Loader />
      <div>Loading...</div>
    </div>
  </Portal>
)

export const Loader = () => (
  <div className="loading">
    <span></span>
    <span></span>
    <span></span>
  </div>
)

export default LoaderScreen
